let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aZXPJ")).then(() => parcelRequire('idu5j'));